import React from 'react'
import { Route } from 'react-router-dom'
import MidMerchantGroupsIndex from './index'
import MidMerchantGroupsResource from './resource'

const MidMerchantGroupsRouter = () => {
  return (
    <>
      <Route
        path="/ui/mid-merchant-groups"
        element={<MidMerchantGroupsIndex />}
      />
      <Route
        path="/ui/mid-merchant-groups/:id/:action"
        element={<MidMerchantGroupsResource />}
      />
      <Route
        path="/ui/mid-merchant-groups/:action"
        element={<MidMerchantGroupsResource />}
      />
    </>
  )
}

export default MidMerchantGroupsRouter
